import React, { Component } from 'react';
import './App.css';
import Header from '../Header';
import Chat from '../Chat';
import Static from '../Static';
import {Scenario} from '../../Scenario';

class App extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {current: Scenario, messages: this.getContent(Scenario), staticOpen: false};
  }

  selectOption(name) {
    let { current } = this.state;
    let newPoint = current.children.filter((child) => child.name === name)[0];
    this.setState({...this.state, current: newPoint, messages: [...this.state.messages, ...this.getContent(newPoint)]});
  }

  getContent(point) {
    let options = point.children.length ? [{type:"options", options: point.children.map((child)=>{ return {name: child.name, mobile_name: child.mobile_name || child.name};})}] : [];
    let content = [].concat(point.content, options);
    return content;
  }

  componentWillUpdate(nextProps, nextState) {
    document.body.classList.toggle('is-static-open', nextState.staticOpen);
  }

  toggleStatic() {
    console.log('toggleStatic');
    if (this.state.staticOpen) {
      this.setState({...this.state, staticOpen: false});
    } else {
      this.setState({...this.state, staticOpen: true});
    }
  }


  render() {
    let { messages, staticOpen } = this.state;
    return (
      <div className="App">
        <div className="App__helper">
          <div className={"App__overlay" + (staticOpen ? " App__overlay--open" : "")}></div>
        </div>
        <Header full={staticOpen} staticOpen={staticOpen} onToggle={this.toggleStatic.bind(this)} />
        <Chat messages={messages} selectOption={this.selectOption.bind(this)} hidden={staticOpen}/>
        <Static open={staticOpen} />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App/index.js
 **/